// extracted by mini-css-extract-plugin
module.exports = {"DealLayoutFooter":"DealLayoutFooter_DealLayoutFooter__W_KU7"};